import { ActionType, createReducer } from 'typesafe-actions'
import { resetCampaignDataAction } from '@/redux/company/handles/resetCampaignDataAction'
import {
  addArchiveChatHandle,
  addChatHandle,
  addMessageOnActiveChatHandle,
  addMessagesOnActiveChatHandle,
  addParticipantToGroupHandle,
  answerChatHandle,
  cancelChatHandle,
  clearActiveChatHandle,
  closeChatHandle,
  createNewChatHandle,
  createNewGroupHandle,
  deleteMessageFromChatHandle,
  exitGroupHandle,
  fetchChatConfigHandle,
  fetchChatsInformationHandle,
  finalCloseChatHandle,
  loadChatsBySearchHandle,
  loadChatsByStatusHandle,
  loadMessagesByChatIdHandle,
  pauseChatHandle,
  promoteAdminGroupHandle,
  readMessagesFromChatHandle,
  removeArchiveChatHandle,
  removeParticipantToGroupHandle,
  resumeChatHandle,
  setActiveChatHandle,
  setActiveChatMessageHandle,
  setActiveChatMessagesHandle,
  setChatFiltersHandle,
  setHasMoreChatsHandle,
  startChatHandle,
  transferChatHandle,
  transferChatToOperatorHandle,
  updateActiveChatHandle,
  updateActiveChatMessageHandle,
  updateArchiveChatHandle,
  updateChatFirebaseHandle,
  updateChatHandle,
  updateGroupHandle,
  updateMessageTextHandle,
  watchChatsCountHandle
} from './handles'
import { fetchMoreChatsHandle } from './handles/fetchMoreChatsAction'
import { setChatsCountByStatusWhenSearchHandle } from './handles/setChatsCountByStatusWhenSearch'
import { unPromoteAdminGroupHandle } from './handles/unPromoteAdminGroupAction'
import { ChatAction, ChatState } from './types'

type Action = ChatAction | ActionType<typeof resetCampaignDataAction>

const initialState: ChatState = {
  isLoadingActiveChatMessagesSuccess: false,
  isLoadingReadMessagesFromChat: false,
  isErrorOnReadMessagesFromChat: false,
  fixedChats: [],
  chats: [],
  archiveChats: [],
  activeChat: null,
  infiniteScrollBottomHack: false,
  hasMoreOpenChats: false,
  hasMoreInProgressChats: false,
  hasMoreChatsWithUnreadMessages: false,
  hasMoreFinishedChats: false,
  openChats: [],
  inProgressChats: [],
  finishedChats: [],
  isErrorOnLoadingOpenChats: false,
  isErrorOnLoadingInProgressChats: false,
  isErrorOnLoadingFinishedChats: false,
  isLoadingOpenChats: false,
  isLoadingInProgressChats: false,
  isLoadingInProgressChatsSearchApi: false,
  isSuccessInProgressChatsSearchApi: false,
  isLoadingFinishedChats: false,
  isErrorOnAnswerChat: false,
  isLoadingAnswerChat: false,
  isErrorOnMessagesByChatId: false,
  isLoadingOnLoadMessagesByChatId: false,
  isSuccessOnMessagesByChatId: false,
  loadMessagesByChatIdError: null,
  isLoadingCreateNewChat: false,
  isErrorOnCreateNewChat: null,
  finishedChatsSearchApi: [],
  chatsWithUnreadMessagesSearchApi: [],
  inProgressChatsSearchApi: [],
  openChatsSearchApi: [],
  isErrorOnUpdateChatFirebase: false,
  isLoadingUpdateChatFirebase: false,
  isErrorOnTransferChat: false,
  isLoadingTransferChat: false,
  isSuccessOnTransferChat: false,
  isErrorOnTransferChatToOperator: false,
  isLoadingTransferChatToOperator: false,
  isSuccessTransferChatToOperator: false,
  isErrorOnCustomButtonCall: false,
  isLoadingCustomButtonCall: false,
  isSuccessOnCustomButtonCall: false,
  isLoadingCancelChat: false,
  isSuccessOnCancelChat: false,
  isErrorOnCancelChat: false,
  chatsCount: { open: 0, inProgress: 0, close: 0 },
  isErrorOnStartChat: false,
  isLoadingStartChat: false,
  isSuccessOnStartChat: false,
  isErrorOnPauseChat: false,
  isLoadingPauseChat: false,
  isSuccessOnPauseChat: false,
  isErrorOnResumeChat: false,
  isLoadingResumeChat: false,
  isSuccessOnResumeChat: false,
  chatFilters: {} as ChatState['chatFilters'],
  isErrorOnCreateNewGroup: false,
  isLoadingCreateNewGroup: false,
  isErrorOnExitGroup: false,
  isLoadingExitGroup: false,
  isSuccessOnExitGroup: false,
  isErrorOnAddParticipantToGroup: false,
  isLoadingAddParticipantToGroup: false,
  isSuccessOnAddParticipantToGroup: false,
  isErrorOnRemoveParticipantToGroup: false,
  isLoadingRemoveParticipantToGroup: false,
  isSuccessOnRemoveParticipantToGroup: false,
  isErrorOnPromoteAdminGroup: false,
  isLoadingPromoteAdminGroup: false,
  isSuccessOnPromoteAdminGroup: false,
  isErrorOnUpdateGroup: false,
  isLoadingUpdateGroup: false,
  isSuccessOnUpdateGroup: false,
  isLoadingExitAndDeleteGroup: false,
  isErrorOnUnPromoteAdminGroup: false,
  isLoadingUnPromoteAdminGroup: false,
  isSuccessOnUnPromoteAdminGroup: false,
  chatConfig: null,
  isErrorOnFetchChatConfig: false,
  isLoadingFetchChatConfig: false,
  isSuccessOnFetchChatConfig: false,
  informations: null,
  isErrorOnFetchChatsInformation: false,
  isLoadingFetchChatsInformation: false,
  isSuccessOnFetchChatsInformation: false,
  isErrorOnFinalCloseChat: false,
  isLoadingFinalCloseChat: false,
  isSuccessOnFinalCloseChat: false,
  isLoadingFetchMoreChatsOpen: false,
  isLoadingFetchMoreChatsInProgress: false,
  isLoadingFetchMoreChatsFinished: false,
  isErrorOnFetchMoreChatsOpen: false,
  isErrorOnFetchMoreChatsInProgress: false,
  isErrorOnFetchMoreChatsFinished: false,
  isSuccessOnFetchMoreChatsOpen: false,
  isSuccessOnFetchMoreChatsInProgress: false,
  isSuccessOnFetchMoreChatsFinished: false,
  isErrorOnSetActiveChat: false,
  isLoadingSetActiveChat: false,
  isSuccessOnSetActiveChat: false,
  openChatsSearchCount: 0,
  inProgressChatsSearchCount: 0,
  closeChatsSearchCount: 0
}

export const chatReducer = createReducer<ChatState, Action>(initialState)
  .handleAction(addChatHandle.asyncAction, addChatHandle.success)
  .handleAction(closeChatHandle.asyncAction.request, closeChatHandle.request)
  .handleAction(closeChatHandle.asyncAction.success, closeChatHandle.success)
  .handleAction(closeChatHandle.asyncAction.failure, closeChatHandle.failure)
  .handleAction(updateChatFirebaseHandle.asyncAction.request, updateChatFirebaseHandle.request)
  .handleAction(updateChatFirebaseHandle.asyncAction.success, updateChatFirebaseHandle.success)
  .handleAction(updateChatFirebaseHandle.asyncAction.failure, updateChatFirebaseHandle.failure)
  .handleAction(updateChatHandle.asyncAction.success, updateChatHandle.success)
  .handleAction(addArchiveChatHandle.asyncAction, addArchiveChatHandle.success)
  .handleAction(updateArchiveChatHandle.asyncAction, updateArchiveChatHandle.success)
  .handleAction(removeArchiveChatHandle.asyncAction, removeArchiveChatHandle.success)
  .handleAction(setActiveChatHandle.asyncAction.request, setActiveChatHandle.request)
  .handleAction(setActiveChatHandle.asyncAction.success, setActiveChatHandle.success)
  .handleAction(setActiveChatHandle.asyncAction.failure, setActiveChatHandle.failure)
  .handleAction(setActiveChatMessageHandle.asyncAction, setActiveChatMessageHandle.success)
  .handleAction(setActiveChatMessagesHandle.asyncAction, setActiveChatMessagesHandle.success)
  .handleAction(loadMessagesByChatIdHandle.asyncAction.request, loadMessagesByChatIdHandle.request)
  .handleAction(loadMessagesByChatIdHandle.asyncAction.success, loadMessagesByChatIdHandle.success)
  .handleAction(loadMessagesByChatIdHandle.asyncAction.failure, loadMessagesByChatIdHandle.failure)
  .handleAction(addMessageOnActiveChatHandle.asyncAction, addMessageOnActiveChatHandle.success)
  .handleAction(readMessagesFromChatHandle.asyncAction.request, readMessagesFromChatHandle.request)
  .handleAction(readMessagesFromChatHandle.asyncAction.success, readMessagesFromChatHandle.success)
  .handleAction(readMessagesFromChatHandle.asyncAction.failure, readMessagesFromChatHandle.failure)
  .handleAction(answerChatHandle.asyncAction.request, answerChatHandle.request)
  .handleAction(answerChatHandle.asyncAction.success, answerChatHandle.success)
  .handleAction(answerChatHandle.asyncAction.failure, answerChatHandle.failure)
  .handleAction(updateActiveChatHandle.asyncAction, updateActiveChatHandle.success)
  .handleAction(deleteMessageFromChatHandle.asyncAction, deleteMessageFromChatHandle.success)
  .handleAction(clearActiveChatHandle.asyncAction, clearActiveChatHandle.success)
  .handleAction(setHasMoreChatsHandle.asyncAction, setHasMoreChatsHandle.success)
  .handleAction(loadChatsByStatusHandle.asyncAction.request, loadChatsByStatusHandle.request)
  .handleAction(loadChatsByStatusHandle.asyncAction.success, loadChatsByStatusHandle.success)
  .handleAction(loadChatsByStatusHandle.asyncAction.failure, loadChatsByStatusHandle.failure)
  .handleAction(loadChatsBySearchHandle.asyncAction.request, loadChatsBySearchHandle.request)
  .handleAction(loadChatsBySearchHandle.asyncAction.success, loadChatsBySearchHandle.success)
  .handleAction(loadChatsBySearchHandle.asyncAction.failure, loadChatsBySearchHandle.failure)
  .handleAction(fetchMoreChatsHandle.asyncAction.success, fetchMoreChatsHandle.success)
  .handleAction(fetchMoreChatsHandle.asyncAction.request, fetchMoreChatsHandle.request)
  .handleAction(fetchMoreChatsHandle.asyncAction.failure, fetchMoreChatsHandle.failure)
  .handleAction(transferChatHandle.asyncAction.request, transferChatHandle.request)
  .handleAction(transferChatHandle.asyncAction.success, transferChatHandle.success)
  .handleAction(transferChatHandle.asyncAction.failure, transferChatHandle.failure)
  .handleAction(transferChatToOperatorHandle.asyncAction.request, transferChatToOperatorHandle.request)
  .handleAction(transferChatToOperatorHandle.asyncAction.success, transferChatToOperatorHandle.success)
  .handleAction(transferChatToOperatorHandle.asyncAction.failure, transferChatToOperatorHandle.failure)
  .handleAction(cancelChatHandle.asyncAction.request, cancelChatHandle.request)
  .handleAction(cancelChatHandle.asyncAction.success, cancelChatHandle.success)
  .handleAction(cancelChatHandle.asyncAction.failure, cancelChatHandle.failure)
  .handleAction(watchChatsCountHandle.asyncAction.success, watchChatsCountHandle.success)
  .handleAction(watchChatsCountHandle.asyncAction.failure, watchChatsCountHandle.failure)
  .handleAction(createNewChatHandle.asyncAction.request, createNewChatHandle.request)
  .handleAction(createNewChatHandle.asyncAction.success, createNewChatHandle.success)
  .handleAction(createNewChatHandle.asyncAction.failure, createNewChatHandle.failure)
  .handleAction(updateActiveChatMessageHandle.asyncAction, updateActiveChatMessageHandle.success)
  .handleAction(updateMessageTextHandle.asyncAction, updateMessageTextHandle.success)
  .handleAction(addMessagesOnActiveChatHandle.asyncAction, addMessagesOnActiveChatHandle.success)
  .handleAction(startChatHandle.asyncAction.request, startChatHandle.request)
  .handleAction(startChatHandle.asyncAction.success, startChatHandle.success)
  .handleAction(startChatHandle.asyncAction.failure, startChatHandle.failure)
  .handleAction(pauseChatHandle.asyncAction.request, pauseChatHandle.request)
  .handleAction(pauseChatHandle.asyncAction.success, pauseChatHandle.success)
  .handleAction(pauseChatHandle.asyncAction.failure, pauseChatHandle.failure)
  .handleAction(resumeChatHandle.asyncAction.request, resumeChatHandle.request)
  .handleAction(resumeChatHandle.asyncAction.success, resumeChatHandle.success)
  .handleAction(resumeChatHandle.asyncAction.failure, resumeChatHandle.failure)
  .handleAction(setChatFiltersHandle.asyncAction, setChatFiltersHandle.success)
  .handleAction(createNewGroupHandle.asyncAction.request, createNewGroupHandle.request)
  .handleAction(createNewGroupHandle.asyncAction.success, createNewGroupHandle.success)
  .handleAction(createNewGroupHandle.asyncAction.failure, createNewGroupHandle.failure)
  .handleAction(exitGroupHandle.asyncAction.request, exitGroupHandle.request)
  .handleAction(exitGroupHandle.asyncAction.success, exitGroupHandle.success)
  .handleAction(exitGroupHandle.asyncAction.failure, exitGroupHandle.failure)
  .handleAction(addParticipantToGroupHandle.asyncAction.request, addParticipantToGroupHandle.request)
  .handleAction(addParticipantToGroupHandle.asyncAction.success, addParticipantToGroupHandle.success)
  .handleAction(addParticipantToGroupHandle.asyncAction.failure, addParticipantToGroupHandle.failure)
  .handleAction(removeParticipantToGroupHandle.asyncAction.request, removeParticipantToGroupHandle.request)
  .handleAction(removeParticipantToGroupHandle.asyncAction.success, removeParticipantToGroupHandle.success)
  .handleAction(removeParticipantToGroupHandle.asyncAction.failure, removeParticipantToGroupHandle.failure)
  .handleAction(promoteAdminGroupHandle.asyncAction.request, promoteAdminGroupHandle.request)
  .handleAction(promoteAdminGroupHandle.asyncAction.success, promoteAdminGroupHandle.success)
  .handleAction(promoteAdminGroupHandle.asyncAction.failure, promoteAdminGroupHandle.failure)
  .handleAction(updateGroupHandle.asyncAction.request, updateGroupHandle.request)
  .handleAction(updateGroupHandle.asyncAction.success, updateGroupHandle.success)
  .handleAction(updateGroupHandle.asyncAction.failure, updateGroupHandle.failure)
  .handleAction(unPromoteAdminGroupHandle.asyncAction.request, unPromoteAdminGroupHandle.request)
  .handleAction(unPromoteAdminGroupHandle.asyncAction.success, unPromoteAdminGroupHandle.success)
  .handleAction(unPromoteAdminGroupHandle.asyncAction.failure, unPromoteAdminGroupHandle.failure)
  .handleAction(fetchChatConfigHandle.asyncAction.request, fetchChatConfigHandle.request)
  .handleAction(fetchChatConfigHandle.asyncAction.success, fetchChatConfigHandle.success)
  .handleAction(fetchChatConfigHandle.asyncAction.failure, fetchChatConfigHandle.failure)
  .handleAction(fetchChatsInformationHandle.asyncAction.request, fetchChatsInformationHandle.request)
  .handleAction(fetchChatsInformationHandle.asyncAction.success, fetchChatsInformationHandle.success)
  .handleAction(fetchChatsInformationHandle.asyncAction.failure, fetchChatsInformationHandle.failure)
  .handleAction(finalCloseChatHandle.asyncAction.request, finalCloseChatHandle.request)
  .handleAction(finalCloseChatHandle.asyncAction.success, finalCloseChatHandle.success)
  .handleAction(finalCloseChatHandle.asyncAction.failure, finalCloseChatHandle.failure)
  .handleAction(setChatsCountByStatusWhenSearchHandle.asyncAction, setChatsCountByStatusWhenSearchHandle.success)
  .handleAction(resetCampaignDataAction, state => ({
    ...state,
    openChats: [],
    inProgressChats: [],
    finishedChats: [],
    activeChat: null,
    openChatsSearchApi: [],
    inProgressChatsSearchApi: [],
    finishedChatsSearchApi: [],
    chatsWithUnreadMessagesSearchApi: [],
    chatsCount: { open: 0, inProgress: 0, close: 0 },
    hasMoreOpenChats: false,
    hasMoreInProgressChats: false,
    hasMoreFinishedChats: false,
    hasMoreChatsWithUnreadMessages: false,
    openChatsSearchCount: 0,
    inProgressChatsSearchCount: 0,
    closeChatsSearchCount: 0,
    infiniteScrollBottomHack: false
  }))
